/*
 * Press-and-hold on a quantity +/- button repeatedly steps the value up or
 * down, instead of requiring a separate tap per unit. Touch-only by design
 * (bound to touchstart/touchend, not click/mousedown) so it only engages
 * on real touch input — mobile per request — and never double-fires on
 * desktop mouse clicks.
 *
 * Delegated on document with touchstart/touchend rather than binding to
 * each .quantity__button individually: quantity-input instances get
 * replaced wholesale when Dawn's cart-drawer JS swaps in freshly-fetched
 * section HTML after a cart change (see assets/cart-icon-bubble-live.js's
 * own comment for a real bug this exact pattern caused elsewhere on this
 * theme) — a per-element binding would silently stop working on any
 * button added after this script first runs. Delegation keeps working
 * regardless of when/how a button entered the DOM.
 *
 * touchstart calls preventDefault() so the browser's own synthetic click
 * (normally fired after touchend as part of touch-to-mouse-event
 * emulation) never happens — this script fires every click itself
 * instead, both the plain single-tap case and the held-repeat case, so
 * there's exactly one place deciding how many increments a given touch
 * produces.
 */
(function () {
  var HOLD_DELAY_MS = 400; // time held before auto-repeat kicks in
  var REPEAT_INTERVAL_MS = 120; // pace of auto-repeat once it starts

  var holdTimeout = null;
  var repeatInterval = null;
  var activeButton = null;
  var didRepeat = false;

  function clearTimers() {
    if (holdTimeout) {
      clearTimeout(holdTimeout);
      holdTimeout = null;
    }
    if (repeatInterval) {
      clearInterval(repeatInterval);
      repeatInterval = null;
    }
  }

  function endHold() {
    if (activeButton && !didRepeat) {
      // Plain tap: preventDefault on touchstart suppressed the browser's
      // own synthetic click, so fire the single increment ourselves.
      activeButton.click();
    }
    clearTimers();
    activeButton = null;
    didRepeat = false;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var button = event.target.closest('quantity-input button[name="plus"], quantity-input button[name="minus"]');
      if (!button || button.disabled) return;

      event.preventDefault();
      activeButton = button;
      didRepeat = false;

      holdTimeout = setTimeout(function () {
        didRepeat = true;
        repeatInterval = setInterval(function () {
          if (!activeButton || activeButton.disabled) {
            clearTimers();
            return;
          }
          activeButton.click();
        }, REPEAT_INTERVAL_MS);
      }, HOLD_DELAY_MS);
    },
    { passive: false }
  );

  document.addEventListener('touchend', endHold);
  document.addEventListener('touchcancel', endHold);
})();
